import { throwError as observableThrowError, Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { ErrorInterceptorService } from '../services/error-interceptor.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private errorInterceptorService: ErrorInterceptorService) {}
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((error, response) => {
        const errorMsg: {
          message: string;
        } = { message: null };

        if (error.error && error.status !== 500) {
          errorMsg.message = '';
          Object.keys(error.error).forEach(key => {
            errorMsg.message += `${error.error[key]}<br>`;
          });
        }
        this.errorInterceptorService.catchError(errorMsg);
        return observableThrowError(error);
      })
    );
  }
}
